
<p-dialog class="charts-popup" 
    header="Model predictions charts" 
    [(visible)]="isVisible"
    [modal]="true"
    [closable]="true" 
    [appendTo]="'body'"
    [draggable]="false"
    [resizable]="false"
    [blockScroll]="true"
    [baseZIndex]="1100"
    [style]="{ width: '800px', maxWidth: '92vw' }"
    [breakpoints]="{ '960px': '92vw', '640px': '96vw' }"
    [styleClass]="'charts-dialog-800'" 
    (onHide)="onCloseModal()">

    <div class="chart-container">
        <p-chart type="line" [data]="lineChartData" [options]="lineOptions" class="chart"></p-chart>
    </div>
    <div class="chart-container">
        <p-chart type="bar" [data]="barChartData" [options]="barOptions" class="chart"></p-chart> 
    </div>
   
</p-dialog>

